import React from 'react';

export const FormGroup: React.FC = (props) => {
  return (
    <div className="mb-5">
      {props.children}
    </div>
  );
}